import { Button, Download01 } from "@dust-tt/sparkle";
import { useTranslation } from "react-i18next";

interface CsvDownloadButtonProps {
  isDownloading: boolean;
  disabled: boolean;
  handleDownload: () => void;
}

export function CsvDownloadButton({
  isDownloading,
  disabled,
  handleDownload,
}: CsvDownloadButtonProps) {
  const { t } = useTranslation();
  return (
    <Button
      icon={Download01}
      variant="outline"
      size="xs"
      tooltip={t("admin.downloadCsv", "Download CSV")}
      onClick={handleDownload}
      disabled={disabled}
      isLoading={isDownloading}
    />
  );
}
